<template>
    <input
        ref="phoneInput"
        type="tel"
        :value="value"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
    />
</template>

<script>
import 'intl-tel-input/build/css/intlTelInput.css'

export default {
    props: {
        value: String,
        placeholder: String,
        options: {
            type: Object,
            default: () => ({
                initialCountry: 'br',
                separateDialCode: true,
            })
        }
    },

    mounted() {
        this.iti = window.intlTelInput(this.$refs.phoneInput, {
            initialCountry: "br",
            separateDialCode: true,
            formatOnDisplay: true,
            strictMode: true,
        })
    },

    destroyed() {
        this.iti?.destroy()
        this.iti = null
        const flagDropdown = document.querySelectorAll('.iti.iti--allow-dropdown.iti--show-flags.iti--inline-dropdown')

         flagDropdown?.forEach((dropdown) => {
            dropdown.remove()
        })
    },

    data() {
        return {
            iti: null
        }
    },

    methods: {
        handleBlur() {
            const formatted = this.iti.getNumber()
            this.$emit("input", formatted)
        }
    },

    beforeDestroy() {
        this.iti?.destroy()
    }
}
</script>